import { formatErrorMessages } from '@core/adapters/errors/transformError';
import type { DomainError } from '@core/domain/errors';
import { Button, Container, Heading, Text } from '@soteria/design-system-ve';

interface CommunityErrorStateProps {
  /**
   * Array of domain errors to display
   */
  errors: DomainError[];

  /**
   * Function to call when the retry button is clicked
   */
  onRetry: () => void;

  /**
   * Optional title to display above the errors
   * @default "Error Loading Community"
   */
  title?: string;
}

/**
 * Component displayed when there's an error loading community details
 */
export function CommunityErrorState({ errors, onRetry, title = 'Error Loading Community' }: CommunityErrorStateProps) {
  if (!errors || errors.length === 0) {
    return null;
  }

  const errorMessages = formatErrorMessages(errors);
  const firstError = errors[0];

  return (
    <Container padding="xxlarge" size="xxl">
      <Heading level="h1">{title}</Heading>

      {errorMessages.length === 1 ? (
        // Single error - display as simple text
        <Text style={{ marginBottom: '1rem' }}>{errorMessages[0]}</Text>
      ) : (
        // Multiple errors - display as bulleted list
        <ul style={{ marginBottom: '1rem' }}>
          {errorMessages.map(message => (
            <li key={`error-${message}`}>
              <Text>{message}</Text>
            </li>
          ))}
        </ul>
      )}

      <Text style={{ marginBottom: '1rem' }}>
        Error category: {firstError.category}, Code: {firstError.code}
      </Text>

      <Button onClick={onRetry}>Retry</Button>
    </Container>
  );
}
